import {combineReducers} from "redux";
import {costPerMw} from "./outputs/costPerMw";
import {energyOutput} from "./outputs/energyOutput";
import {environmentalImpact} from "./outputs/environmentalImpact";


/**
 * combine outputs into a single reducer
 * @type {Reducer<any>}
 */
export const outputs = combineReducers({
    energyOutput,
    costPerMw,
    environmentalImpact
});


// WEBPACK FOOTER //
// ./src/ts/store/reducers/outputs.ts